import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { producaov2 } from '../../../../services/apis';
import { toast } from 'react-toastify';

export default function PhaseStatusSelect({
  phaseStatusOptions = [],
  defaultPhaseStatus,
  applicationID,
  applicationPhaseID,
  onSubmitStatus = () => {}
}) {
  const [selectedStatus, setSelectedStatus] = useState(defaultPhaseStatus);
  const [loading, setLoading] = useState(false);

  const handleChangePhaseStatus = async (e) => {
    const phaseStatusID = e.target.value;
    const newPhaseStatus = phaseStatusOptions.find(status => `${status.id}` === `${phaseStatusID}`);

    const prevStatus = selectedStatus;

    setLoading(true);

    try {
      setSelectedStatus(newPhaseStatus);

      await producaov2.put(`/admin/project-applications/${applicationID}/phases/${applicationPhaseID}`, {
        status: newPhaseStatus?.id
      });

      toast.success('Status da etapa atualizado com sucesso');

      onSubmitStatus();
    } catch (error) {
      toast.error('Houve um erro ao atualizar o status da etapa');

      setSelectedStatus(prevStatus);
    } finally {
      setLoading(false);
    }
  }

  return (
    <FormControl variant="outlined" size="small" disabled={loading} style={{ width: '160px' }} title={selectedStatus?.name}>
      <Select
        title={selectedStatus?.description}
        value={selectedStatus?.id}
        onChange={handleChangePhaseStatus}
      >
        {phaseStatusOptions?.map(status => {
          return <MenuItem title={status?.description} value={status?.id}>{status?.name}</MenuItem>
        })}
      </Select>
    </FormControl>
  );
}